import React, { useState, useEffect ,useRef } from 'react';
import axios from 'axios';
import { db } from '../firebase';
import { collection, addDoc, query, getDocs, where, Timestamp } from 'firebase/firestore';
import './ItemFormI.css';
import folder from '../assets/folder.png';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';

const units = ['פצ״ן', 'פד״ם', 'פקמ״ז', 'ז״י', 'חה״א', 'חה״י', 'פקע״ר', 'אט״ל', 'אמ״ן', 'אכ״א', 'מטכ״ל', 'תקשוב', 'מפקדת הרבנות הצבאית']; // רשימת פיקודים
const categories = ['ציוד הדת בשטח', 'ספרי תורה בשטח', 'עירוב שבת', 'ציוד חגי תשרי', 'ציוד חנוכה', 'ציוד פסח', 'אחר']; // קטגוריות זמינות

const ItemForml = ({ onFormSubmit = () => { } }) => {
  const [unit, setUnit] = useState('');
  const [category, setCategory] = useState('');
  const [file, setFile] = useState(null);
  const [description, setDescription] = useState('');
  const [location, setLocation] = useState('');
  const [loading, setLoading] = useState(false);
  const [leaderUnit, setLeaderUnit] = useState('');
  const [unitUploads, setUnitUploads] = useState({});
  const [viewCategories, setViewCategories] = useState(false);
  const [images, setImages] = useState([]);
  const [totalUnitPhotos, setTotalUnitPhotos] = useState(0); // סך כל התמונות עבור הפיקוד
  const [showModal, setShowModal] = useState(true); // חלון לאישור תנאים
  const [categoryImageCounts, setCategoryImageCounts] = useState({}); // This will store the image counts for each category
  const [showCategories, setShowCategories] = useState(true); // Toggle between categories and images
  const fileInputRef = useRef(null);


  // Fetch total uploads and leader unit
  useEffect(() => {
    const fetchUnitUploads = async () => {
      const unitCounts = {};
      const q = query(collection(db, 'unit_images'));

      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        const data = doc.data();
        unitCounts[data.unit] = (unitCounts[data.unit] || 0) + 1;
      });

      setUnitUploads(unitCounts);

      const leader = Object.keys(unitCounts).reduce(
        (a, b) => (unitCounts[a] > unitCounts[b] ? a : b),
        ''
      );
      setLeaderUnit(leader);
    };

    fetchUnitUploads();
  }, [category]);

  // Change background on load
  useEffect(() => {
    changeBodyBackground('linear-gradient(to bottom, #b0dffb, rgb(255 255 255))');
    return () => changeBodyBackground(''); // Reset background on unmount
  }, []);

  const changeBodyBackground = (background) => {
    document.body.style.background = background;
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const uploadToCloudinary = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', 'ml_default');

    try {
      const response = await axios.post(
        'https://api.cloudinary.com/v1_1/dfgw9dqmg/image/upload',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        }
      );
      return response.data.secure_url;
    } catch (error) {
      console.error('שגיאה בהעלאת תמונה:', error.response?.data || error.message);
      alert('העלאת התמונה נכשלה. אנא נסה שוב.');
      throw error;
    }
  };

  const fetchImages = async () => {
    try {
      const imagesQuery = query(
        collection(db, 'unit_images'),
        where('unit', '==', unit),
        where('category', '==', category)
      );
      const querySnapshot = await getDocs(imagesQuery);
      const fetchedImages = [];
      querySnapshot.forEach((doc) => {
        fetchedImages.push(doc.data().imageUrl);
      });

      setImages(fetchedImages); // Update the images state to re-render the images
    } catch (error) {
      console.error('Error fetching images:', error);
    }
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (!file) {
        alert('אנא בחר קובץ להעלאה.');
        setLoading(false);
        return;
      }

      const uploadedImageUrl = await uploadToCloudinary(file);

      await addDoc(collection(db, 'unit_images'), {
        unit,
        category,
        imageUrl: uploadedImageUrl,
        description,
        location,
        uploadDate: Timestamp.fromDate(new Date()),
      });

      alert('התמונה הועלתה בהצלחה!');
      // onFormSubmit();
      setUnit('');
      setCategory('');
      setFile(null);
      setDescription('');
      setLocation('');
      setFile('');

      if (fileInputRef.current) {
        fileInputRef.current.value = ''; // Clear the file input
      }

      // Re-fetch data from the database
      fetchImages(); // Call the function that fetches images from Firestore
    } catch (error) {
      alert('העלאת התמונה נכשלה. אנא נסה שוב.');
    } finally {
      setLoading(false);
    }
  };

  // When a unit is selected
  // const handleUnitChange = async (e) => {
  //   const selectedUnit = e.target.value;
  //   setUnit(selectedUnit);
  //   setCategory('');
  //   setImages([]);

  //   // Fetch total number of photos uploaded by this unit
  //   const imagesQuery = query(collection(db, 'unit_images'), where('unit', '==', selectedUnit));
  //   const querySnapshot = await getDocs(imagesQuery);
  //   setTotalUnitPhotos(querySnapshot.size);
  // };

  const handleUnitChange = async (e) => {
    const selectedUnit = e.target.value;
    setUnit(selectedUnit);
    setCategory('');
    setImages([]);

    const categoryImageCounts = {};

    // Loop through each category and get the count of images
    for (const cat of categories) {
      const imagesQuery = query(
        collection(db, 'unit_images'),
        where('unit', '==', selectedUnit),
        where('category', '==', cat)
      );
      const querySnapshot = await getDocs(imagesQuery);
      categoryImageCounts[cat] = querySnapshot.size;
    }

    // Set the count of images for each category
    setCategoryImageCounts(categoryImageCounts);
  };

  const handleCategoryClick = async (selectedCategory) => {
    setCategory(selectedCategory);
    setShowCategories(false); // Hide categories and show images

    const imagesQuery = query(
      collection(db, 'unit_images'),
      where('unit', '==', unit),
      where('category', '==', selectedCategory)
    );

    const querySnapshot = await getDocs(imagesQuery);
    const fetchedImages = [];
    querySnapshot.forEach((doc) => {
      fetchedImages.push(doc.data().imageUrl);
    });

    setImages(fetchedImages);
  };


  // Back to categories view
  const handleBackToCategories = () => {
    setImages([]);
    setCategory('');
  };

  // Back to the upload view
  const handleBackToUpload = () => {
    setViewCategories(false);
    setCategory('');
  };

  // View categories
  const handleViewCategories = () => {
    setViewCategories(true);
    setCategory('');
  };


  const handleDownloadAllCommandImages = async () => {
    if (!unit) {
      alert('יש לבחור פיקוד.');
      return;
    }

    setLoading(true);
    const zip = new JSZip();
    const imgFolder = zip.folder("images");

    // Loop through all categories
    const categoryPromises = categories.map(async (selectedCategory) => {
      const imagesQuery = query(
        collection(db, 'unit_images'),
        where('unit', '==', unit),
        where('category', '==', selectedCategory)
      );
      const querySnapshot = await getDocs(imagesQuery);

      if (!querySnapshot.empty) {
        const categoryFolder = imgFolder.folder(selectedCategory); // Create folder for each category

        // Add each image to the respective category folder
        const imagePromises = querySnapshot.docs.map(async (doc, idx) => {
          const imageUrl = doc.data().imageUrl;
          const description = doc.data().description || '';
          const location = doc.data().location || '';
          const fileName = `${description}_${location}_${idx + 1}.jpg`; // Create file name using description and location

          try {
            const response = await axios.get(imageUrl, { responseType: 'blob' });
            categoryFolder.file(fileName, response.data, { binary: true });
          } catch (error) {
            console.error(`שגיאה בהורדת תמונה: ${imageUrl}`, error);
          }
        });

        await Promise.all(imagePromises);
      }
    });

    await Promise.all(categoryPromises);

    // Generate the ZIP file and save it
    zip.generateAsync({ type: 'blob' }).then((blob) => {
      saveAs(blob, `all_images_${unit}.zip`);
      setLoading(false);
    });
  };

  // Download all images in a category
  const handleDownloadAll = async () => {
    if (!images.length) {
      alert('אין תמונות להורדה או שלא נבחר פיקוד .');
      return;
    }

    setLoading(true);
    const zip = new JSZip();
    const imgFolder = zip.folder("images");

    // Download each image and add to zip
    const imagePromises = images.map(async (url, idx) => {
      try {
        const response = await axios.get(url, { responseType: 'blob' });
        const fileName = `image${idx + 1}.jpg`;
        imgFolder.file(fileName, response.data, { binary: true });
      } catch (error) {
        console.error(`הורדת התמונה נכשלה: ${url}`, error);
      }
    });

    await Promise.all(imagePromises);

    // Generate zip and save
    zip.generateAsync({ type: 'blob' }).then((blob) => {
      saveAs(blob, `images_${unit}_${category}.zip`);
      setLoading(false);
    });
  };

  const handleModalClose = () => {
    setShowModal(false);
  };

  return (
    <div className="upload-container">
      {/* Modal for terms confirmation */}
      {showModal && (
        <div className="modal">
          <div className="modal-content" style={{ textAlign: 'center' }}>
            <h2 style={{ textAlign: 'center' }}>אישור תנאי השימוש</h2>
            <p style={{ marginBottom: '10px' }}>
              כל התמונות והחומרים המועלים למאגר אינם מוגנים בזכויות יוצרים.
            </p>
            <p style={{ marginBottom: '10px' }}>המשתמשים רשאים להעתיק, לערוך, להפיץ ולהשתמש בתמונות לצרכים פרטיים, חינוכיים, שיווקיים או לכל מטרה אחרת, ללא צורך בקבלת אישור וללא מתן קרדיט ליוצרים.</p>
            <p style={{ marginBottom: '10px' }}>
              העלאת תמונות למאגר מהווה הצהרה כי מעלה התוכן הוא הבעלים החוקי של התוכן והתוכן נקי מזכויות יוצרים.
            </p>

            <p style={{ marginBottom: '10px' }}>אין להעלות תמונות המוגנות בזכויות יוצרים או מכילות חומר שהשימוש בו מוגבל על פי חוק .</p>

            <p style={{ marginBottom: '10px'  , fontWeight:'bold'}}>
              ביטחון מידע: מטעמי ביטחון מידע, יש להקפיד על העלאת תוכן בלמ״סי בלבד.
            </p>

            <p style={{ marginBottom: '10px' , fontWeight:'bold'}}>
              כמו כן, יש להימנע מפירוט המיקום המדויק בה צולמה התמונה. (ניתן: איזור גאוגרפי) .
            </p>
            <button onClick={handleModalClose}>אני מאשר</button>
          </div>
        </div>
      )}

      <div className="leaderboard">
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <span className="nameSite" style={{ color: '#3f3f3f' }}>מערכת </span>
          <span className="nameSite" style={{ color: '#243a6e' }}>שיתוף </span>
          <span className="nameSite" style={{ color: '#243a6e' }}>תמונות </span>
        </div>
        <div className="nameSite2">ציוד הדת הצה״לי- מלחמת ״חרבות ברזל״</div>
        <div className="nameSite3" style={{textAlign:'center'}}>מדור ציוד דת ולוגיסטיקה- כאן בשבילך !</div>

        {leaderUnit ? (
          <>
            <h2 style={{ marginTop: '0px', marginBottom: '8px' }}>
              הפיקוד המוביל הוא <span className="leader-unit">{leaderUnit}</span> עם {unitUploads[leaderUnit]} העלאות!
            </h2>

            <div className="running-line-container">
              <div className="running-line">
                {Object.keys(unitUploads).map((unit) => (
                  <span key={unit} className="unit-count">
                    {unit}: {unitUploads[unit]} העלאות
                  </span>
                ))}
              </div>
            </div>

          </>
        ) : (
          <p>טוען לוח מובילים...</p>
        )}
      </div>

      {viewCategories ? (
        <div>
          <h2 style={{marginTop:'5px'}}>בחר פיקוד וקטגוריה</h2>

          {/* Unit Selection */}
          <label>בחר פיקוד</label>
          <select value={unit} onChange={handleUnitChange} required>
            <option value="" disabled>בחר פיקוד</option>
            {units.map((unit) => (
              <option key={unit} value={unit}>
                {unit}
              </option>
            ))}
          </select>

          {/* Display total photo count for the selected unit */}
          {unit && <p>סה"כ תמונות שהועלו על ידי {unit}: {unitUploads[unit]}</p>}

          {(unit && categories === '') && (
            <button className="download-button-command" onClick={handleDownloadAllCommandImages} disabled={loading}>
              {loading ? 'מוריד...' : 'הורד את כל התמונות מהפיקוד'}
            </button>
          )}
          {unit && category === '' ? (
            <div className="categories-container">
              {categories.map((cat) => (
                <div key={cat} className="category-folder" onClick={() => handleCategoryClick(cat)}>
                  <img src={folder} alt="תיקייה" className="folder-icon" />
                  <p>{cat}</p>
                  <div className="image-count-badge">
                    {categoryImageCounts[cat] || 0} {/* Display the number of images */}
                  </div>
                </div>
              ))}
              <button className="download-button-command" onClick={handleDownloadAllCommandImages} disabled={loading}>
                {loading ? 'מוריד...' : 'הורד את כל התמונות מהפיקוד'}
              </button>
            </div>
          ) : (

            <div>
              {unit &&
                <div>
                  <div className="images-container">
                    {images.map((imageUrl, idx) => (
                      <img key={idx} src={imageUrl} alt="תמונה" className="uploaded-image" />
                    ))}
                  </div>
                  <button onClick={handleBackToCategories}>חזרה לקטגוריות</button>
                </div>
              }

              {unit && <div className="download-buttons-container">
                <button className="download-button-category" onClick={handleDownloadAll} disabled={loading}>
                  {loading ? 'מוריד...' : 'הורד את כל התמונות מהקטגוריה '}
                </button>
              </div>}

              {viewCategories === false && <button onClick={handleBackToCategories}>צפה בתמונות</button>
              }
            </div>
          )}
          <button onClick={handleBackToUpload}>חזרה להעלאה</button>
        </div>
      ) : (
        <form onSubmit={handleSubmit} className="upload-form">
          <h2 style={{ marginTop: '0px' }}>העלה תמונה לפי פיקוד וקטגוריה</h2>

          <select value={unit} onChange={handleUnitChange} required>
            <option value="" disabled>בחר פיקוד</option>
            {units.map((unit) => (
              <option key={unit} value={unit}>
                {unit}
              </option>
            ))}
          </select>

          <select value={category} onChange={(e) => setCategory(e.target.value)} required>
            <option value="" disabled>בחר קטגוריה</option>
            {categories.map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>

          {/* <textarea
            style={{ width: '260px' }}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="הוסף תיאור לתמונה *רשות"
          />
          <input
            type="text"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
            placeholder="הזן מיקום גיאוגרפי *רשות"
          /> */}

          <div className="textarea-input-container">
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="הוסף תיאור לתמונה"
              rows="3"
            />
            <input
              type="text"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              placeholder="הזן מיקום גיאוגרפי "
            />
          </div>

          <input type="file" onChange={handleFileChange} ref={fileInputRef} required />
          <div className="security-note">
            <p>מטעמי ביטחון מידע, יש להקפיד על העלאת תוכן בלמ״סי בלבד. כמו כן, יש להימנע מפירוט המיקום המדויק בה צולמה התמונה. (ניתן: איזור גאוגרפי)</p>
          </div>
          <button type="submit" disabled={!unit || !category || loading}>
            {loading ? 'מעלה...' : 'העלה'}
          </button>
        </form>
      )}

      {!viewCategories && (
        <button style={{ background: '#66879d' }} onClick={handleViewCategories}>
          צפה בתמונות
        </button>
      )}
    </div>
  );
};

export default ItemForml;
